<template>
    <svg
        id="Human"
        xmlns="http://www.w3.org/2000/svg"
        width="28.744"
        height="33.065"
        viewBox="0 0 28.744 33.065"
    >
        <path
            id="Pfad_263"
            data-name="Pfad 263"
            d="M125.886,89.736c-8.059,0-14.372-3.9-14.372-8.884s6.313-8.885,14.372-8.885,14.372,3.9,14.372,8.885S133.945,89.736,125.886,89.736Zm0-15.3c-6.473,0-11.942,2.938-11.942,6.414s5.469,6.412,11.942,6.412,11.942-2.937,11.942-6.412S132.359,74.439,125.886,74.439Z"
            transform="translate(-111.514 -56.671)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_264"
            data-name="Pfad 264"
            d="M123.368,80.433c-4.3,0-7.793-3.981-7.793-8.874s3.5-8.874,7.793-8.874,7.793,3.981,7.793,8.874S127.666,80.433,123.368,80.433Zm0-15.276c-2.958,0-5.364,2.871-5.364,6.4s2.406,6.4,5.364,6.4,5.364-2.872,5.364-6.4S126.325,65.157,123.368,65.157Z"
            transform="translate(-108.996 -62.685)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ProfileIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
            default: "fill-white",
        },
    },
});
</script>
